const LIVE_PAYMENT_STATUSES = new Set(['authorized', 'paid', 'manual_resolution']);

/**
 * Creator-side shell trip: open/confirmed but no participant has completed checkout.
 * manual_resolution counts as live (money was captured).
 */
export function isUnauthorizedShellTrip(trip, participants) {
  if (!trip) return false;
  if (!['open', 'confirmed'].includes(trip.status)) return false;

  const list = participants ?? [];
  const hasLivePayment = list.some((p) => LIVE_PAYMENT_STATUSES.has(p.payment_status));
  return !hasLivePayment;
}
